package com.zq.webproject.ui.invite
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.zq.webproject.network.Repository
import com.zq.webproject.utils.TokenManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch


/**
 * 邀请页面ViewModel
 * 管理邀请码和邀请链接
 */
class InviteViewModel {
    private val repository = Repository()
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Main)

    // 邀请码
    var inviteCode by mutableStateOf<String?>(null)
        private set

    // 邀请链接
    var inviteLink by mutableStateOf<String>("")
        private set

    // 加载状态
    var isLoading by mutableStateOf(false)
        private set

    // 错误信息
    var errorMessage by mutableStateOf<String?>(null)
        private set

    init {
        println("InviteViewModel - 初始化邀请页面") // 日志输出
        loadInviteCode()
    }

    /**
     * 加载用户邀请码
     * 从 TokenManager 中直接获取登录时保存的邀请码
     */
    fun loadInviteCode() {
        scope.launch {
            val token = TokenManager.getToken()
            if (token.isNullOrEmpty()) {
                println("InviteViewModel - Token为空，无法加载邀请码") // 日志输出
                errorMessage = "未登录，无法获取邀请码"
                return@launch
            }

            println("InviteViewModel - 开始加载邀请码") // 日志输出

            // 直接从 TokenManager 获取登录时保存的邀请码
            val referralCode = TokenManager.getReferralCode()
            if (referralCode.isNullOrEmpty()) {
                println("InviteViewModel - 邀请码为空，请先登录") // 日志输出
                errorMessage = "邀请码为空，请先登录"
                return@launch
            }
            
            inviteCode = referralCode

            // 生成邀请链接（使用 inviteCode 参数，扫码后自动跳转注册页）
            inviteLink = "https://shop.aiotzq.com/?inviteCode=$inviteCode"

            println("InviteViewModel - 邀请码加载成功: $inviteCode") // 日志输出
            println("InviteViewModel - 邀请链接: $inviteLink") // 日志输出
        }
    }

    /**
     * 清除错误信息
     */
    fun clearError() {
        errorMessage = null
    }
}